export default "__VITE_ASSET__D0ME0DjM__"